export interface BankInformation {
  iban: string;
  bic: string;
  bankIdentifierCode: string;
  bankAccountNumber: string;
  bankName: string;
}
